import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3fe4c425"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "ai-btn__star-icon" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "ai-btn__star-icon" }, null, -1));
export default /*#__PURE__*/ _defineComponent({
    __name: 'AIButton',
    props: {
        label: {},
        link: {}
    },
    emits: ['on-click'],
    setup(__props, { emit }) {
        const props = __props;
        function handleClick() {
            emit('on-click');
        }
        return (_ctx, _cache) => {
            return (props.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: props.link,
                    class: "ai-btn",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    referrerpolicy: "no-referrer-when-downgrade",
                    onClick: handleClick
                }, [
                    _hoisted_2,
                    _createElementVNode("span", null, _toDisplayString(props.label), 1)
                ], 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ai-btn",
                    onClick: handleClick
                }, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(props.label), 1)
                ]));
        };
    }
});
